import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionBtnComponent } from '@enginuity/core/molecules/action-btn/action-btn.component';

@Component({
  selector: 'app-sidebar-collapse',
  imports: [CommonModule, ActionBtnComponent],
  templateUrl: './sidebar-collapse.component.html',
  styleUrls: ['./sidebar-collapse.component.scss'],
})
export class SidebarCollapseComponent {
  @Output() custom_click = new EventEmitter<any>();

  @Input()
  title = 'Collapse sidebar';

  @Input()
  type: 'open' | 'back' = 'back';

  @Input()
  icon = 'caret_left';

  @Input()
  background: 'white' | 'grey' = 'white';

  handleClose($event: MouseEvent) {
    $event.preventDefault();
    this.custom_click.emit();
  }
}
